export const config = {
  "label": "dev",
  "defaultConfigUrl": "https://quai-md-runtime-dev-default-rtdb.firebaseio.com/_frontend/default.json",
  "configUrl": "https://quai-md-runtime-dev-default-rtdb.firebaseio.com/_frontend/advisor.json"
};